document.addEventListener("DOMContentLoaded", function() {
  const selectSizeBtn = document.getElementById("selectSizeBtn");
  const sizeOptions = document.getElementById("sizeOptions");

  function toggleSizeOptions() {
    if (sizeOptions.style.display === "none") {
      sizeOptions.style.display = "grid";
      selectSizeBtn.classList.add("is-open");
    } else {
      sizeOptions.style.display = "none";
      selectSizeBtn.classList.remove("is-open");
    }
  }

  selectSizeBtn?.addEventListener("click", function(event) {
    event.stopPropagation();
    toggleSizeOptions();
  });

  document.addEventListener("click", function(event) {
    if (selectSizeBtn != null &&
      event.target !== selectSizeBtn &&
      !selectSizeBtn.contains(event.target) &&
      event.target !== sizeOptions &&
      !sizeOptions.contains(event.target)
    ) {
      sizeOptions.style.display = "none";
      selectSizeBtn.classList.remove("is-open");
    }
  });

  const buttons = document.querySelectorAll("#sizeOptions .radio__button input");
  const buttonTexts = document.querySelector("#selectSizeBtn span");
  const priceElement = document.querySelector("[data-product-price]");

  buttons.forEach((button) => {
    button.addEventListener("click", function() {
      buttonTexts.textContent = theme.strings.Size + " " + this.value;

      if (this.classList.contains("unavailable")) {
        if (priceElement) {
          priceElement.style.opacity = "0.3"; 
        }
      } else {
        if (priceElement) {
          priceElement.style.opacity = "1";
        }
      }
      const soldOutPriceElements = document.querySelectorAll(".variant--soldout .product__price");
      soldOutPriceElements.forEach((soldOutPrice) => {
        soldOutPrice.style.opacity = "1";
      });
    });
  });
  document.dispatchEvent(new CustomEvent("size:selection:finished"));
});
